<template>
  <b-container class="py-3 py-md-5 order-list">
    <b-row>
      <div class="col-auto d-none d-md-block" style="width: 250px">
        <div class="side">
          <form @submit.stop.prevent="searchOrderSubmit">
            <b-input-group class="mb-2 ml-auto search-group">
              <b-form-input
                v-model="searchOrder"
                placeholder="廠商名稱、訂單編號"
              ></b-form-input>
              <b-button-close
                class="pr-2"
                v-if="searchOrder"
                @click="clearOrderFilter"
              ></b-button-close>
              <b-input-group-prepend>
                <b-button class="px-2" type="submit">
                  <b-icon-search></b-icon-search>
                </b-button>
              </b-input-group-prepend>
            </b-input-group>
          </form>
          <div class="filter-box my-4 p-3">
            <div class="filter-title py-2 mb-2">
              透過以下分類篩選：
            </div>
            <div class="filter-item">
              <div class="filter-item-list">
                <b-form-group label="付款狀態" class="variant-platform">
                  <b-form-checkbox-group
                    v-model="pay_status"
                    :options="pay_status_list"
                    name="filterTag"
                    stacked
                  ></b-form-checkbox-group>
                </b-form-group>
              </div>
              <hr />
              <div class="filter-item-list">
                <b-form-group label="出貨狀態" class="variant-platform">
                  <b-form-checkbox-group
                    v-model="shopping_status"
                    :options="shopping_status_list"
                    name="filterTag"
                    stacked
                  ></b-form-checkbox-group>
                </b-form-group>
              </div>
            </div>
          </div>
          <b-button block squared @click="clearFilter" variant="platform_main"
            >清除篩選</b-button
          >
        </div>
      </div>
      <div class="col order_list">
        <div
          class="pb-3 d-flex d-md-none justify-content-between align-items-center"
        >
          <form @submit.stop.prevent="searchOrderSubmit" style="width: 100%;">
            <b-input-group class="mb-2 ml-auto search-group">
              <b-form-input
                v-model="searchOrder"
                placeholder="廠商名稱、訂單編號"
              ></b-form-input>
              <b-button-close
                class="pr-2"
                v-if="searchOrder"
                @click="clearOrderFilter"
              ></b-button-close>
              <b-input-group-prepend>
                <b-button class="px-2" type="submit">
                  <b-icon-search></b-icon-search>
                </b-button>
              </b-input-group-prepend>
            </b-input-group>
          </form>
          <b-button
            variant="link"
            class="nav-link p-0 ml-2"
            :class="{ has_filter: hasFilter }"
            v-b-toggle.filterSidebar
            style="width: 60px;"
          >
            <b-icon icon="funnel" variant="platform_main"></b-icon>
            <small class="text-platform_main text-nowrap">篩選</small>
          </b-button>
        </div>
        <div class="order-item mb-3" v-if="orderList">
          <div class="border shopping_car-header mb-3 py-2 d-none d-md-flex">
            <div class="col shopping_car-product-name">
              商品
            </div>
            <div class="col-auto shopping_car-product-price text-center">
              單價
            </div>
            <div class="col-auto shopping_car-product-count text-center">
              數量
            </div>
            <div class="col-auto shopping_car-product-subtotal text-center">
              小計
            </div>
            <div class="col-auto shopping_car-product-subtotal text-center">
              成交金額
            </div>
          </div>
          <div
            class="shopping_car-group mb-3"
            v-for="item in orderList.data"
            :key="item.order_serial"
          >
            <div
              class="border row mx-0 justify-content-between align-items-center shopping_car-header py-2"
            >
              <div class="col-12 col-lg shopping_car-product-name">
                <router-link
                  :to="{
                    name: '廠商介紹',
                    query: { search: item.company_name }
                  }"
                  v-slot="{ href }"
                >
                  <b-button variant="link" :href="href" class="p-0 text-dark">{{
                    item.company_name
                  }}</b-button>
                </router-link>
              </div>
              <div class="col-6 col-lg-auto">
                <small>
                  付款狀態：
                  <span
                    :class="{
                      'text-danger': item.pay_status == 0,
                      'text-manage_sub': item.pay_status == 2,
                      'text-success': item.pay_status == 1
                    }"
                    >{{ getPayStatuName(item.pay_status) }}</span
                  >
                </small>
              </div>
              <div class="col-6 col-lg-auto">
                <small>
                  出貨狀態：
                  <span
                    :class="{
                      'text-danger': item.shopping_status == 0,
                      'text-manage_sub': item.shopping_status == 2,
                      'text-success': item.shopping_status == 1
                    }"
                    >{{ getShoppingStatuName(item.shopping_status) }}</span
                  >
                </small>
              </div>
              <div class="col-12 col-lg-auto">
                <small>
                  最後更新時間：
                  <span>{{ format(item.updated_at, "yyyy-MM-dd hh:mm") }}</span>
                </small>
              </div>
            </div>
            <div
              class="border border-top-0 row mx-0 shopping_car-item align-items-center py-2"
              v-for="product in item.detail"
              :key="item.order_serial + product.product_serial_no"
            >
              <div class="col shopping_car-product-name">
                <div class="row align-items-center no-gutters ">
                  <div class="col-auto">
                    <div class="imgBox p-3 p-lg-2">
                      <div class="imgBox-inner">
                        <div class="imgBox-fit">
                          <img
                            :src="getAllImgUrl(product.cover_image)"
                            class="card-img-top"
                            :alt="product.product_name"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col">
                    <p class="shopping_car-product-text mb-0">
                      {{ product.product_serial_no }}
                    </p>
                    <h5 class="shopping_car-product-title">
                      {{ product.product_name }}
                    </h5>
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-auto mb-2">
                <div
                  class="row align-items-center flex-md-row justify-content-between"
                >
                  <div class="col-12 col-md-auto shopping_car-product-price">
                    {{ toThousands(product.price) }}
                  </div>
                  <div class="col-auto ml-auto shopping_car-product-count">
                    X {{ product.count }}
                  </div>
                  <div class="col-auto shopping_car-product-subtotal">
                    <del>{{ toThousands(product.price * product.count) }}</del>
                  </div>
                  <div
                    class="col-auto shopping_car-product-subtotal text-manage_sub"
                  >
                    {{ product.total_price }}
                  </div>
                </div>
              </div>
            </div>
            <div
              class="border border-top-0 row mx-0 justify-content-between align-items-center shopping_car-footer py-2"
            >
              <div class="col-12 col-lg">
                <small>訂單編號：{{ item.order_serial }}</small>
              </div>
              <div class="col-12 col-sm-6 col-lg-auto">
                總金額
                <del>{{
                  toThousands(companyTotalPrice(item.order_serial))
                }}</del>
              </div>
              <div class="col-12 col-sm-6 col-lg-auto text-right">
                成交總金額
                <span class="text-manage_sub">{{
                  item.price || "未確認"
                }}</span>
              </div>
            </div>
          </div>
          <div v-if="!orderList.data.length" class="text-center">查無訂單</div>
        </div>
        <b-pagination
          v-if="orderList && orderList.data.length"
          align="right"
          v-model="orderList.current_page"
          :total-rows="orderList.total"
          :per-page="orderList.per_page"
          first-number
          last-number
          @click.native="pagination(orderList.current_page)"
          class="platform_main"
        ></b-pagination>
      </div>
    </b-row>
    <b-sidebar
      id="filterSidebar"
      shadow
      z-index="99"
      right
      backdrop
      title="搜尋篩選"
      class="sidebar"
      header-class="flex-row-reverse border-bottom"
    >
      <div class="px-3 py-2">
        <b-form-group label="付款狀態">
          <b-form-checkbox-group
            v-model="pay_status"
            :options="pay_status_list"
            name="filterTag"
            stacked
          ></b-form-checkbox-group>
        </b-form-group>
        <hr />
        <b-form-group label="出貨狀態">
          <b-form-checkbox-group
            v-model="shopping_status"
            :options="shopping_status_list"
            name="filterTag"
            stacked
          ></b-form-checkbox-group>
        </b-form-group>
      </div>
      <template v-slot:footer>
        <b-button block squared @click="clearFilter" variant="platform_main"
          >清除篩選</b-button
        >
      </template>
    </b-sidebar>
  </b-container>
</template>
<style lang="scss" scoped>
.order-list {
  min-height: calc((var(--vh, 1vh) * 100) - 104px - 64px - 35px);
}
.side {
  position: sticky;
  top: 20px;
}
.sidebar {
  ::v-deep .close {
    margin-left: auto;
    margin-right: 0 !important;
  }
  ::v-deep header {
    font-size: 20px;
  }
  ::v-deep .b-sidebar-footer {
    a {
      color: #fff;
    }
  }
  ::v-deep .custom-checkbox {
    margin: 10px 0;
  }
}
.search-group {
  border: 1px solid #dee2e6;
  max-width: 100%;
  button {
    background-color: #fff;
    border: none;
    border-right: 1px solid #dee2e6;
    border-radius: 0;
    color: #bdbdbd;
  }
  .form-control {
    border: none;
    border-radius: 0;
    &:focus {
      box-shadow: none;
    }
  }
}
.filter-box {
  border: 1px solid #dee2e6;
  ::v-deep .custom-checkbox {
    margin: 10px 0;
  }
  & ::v-deep .col-form-label {
    color: #616870;
    padding-bottom: 0;
  }
}
.has_filter {
  position: relative;
  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 8px;
    height: 8px;
    border-radius: 5px;
    background-color: $platform_main;
  }
}
.order_list ::v-deep .pagination {
  .page-item {
    &:first-child {
      .page-link {
        border-radius: 0;
      }
    }
    &:last-child {
      .page-link {
        border-radius: 0;
      }
    }
  }
}
.shopping_car {
  &-header {
    background-color: #f2f2f2;
  }
  &-product-price,
  &-product-subtotal {
    width: 100px;
    text-align: right;
  }
  &-product-price {
    @include media-breakpoint-down(sm) {
      display: none;
    }
  }
  &-product-count {
    width: 100px;
    text-align: right;
    @include media-breakpoint-down(sm) {
      ::v-deep .input-group {
        display: inline-flex;
        margin-bottom: 10px;
      }
    }
  }
  &-product-delete {
    width: 65px;
    @include media-breakpoint-down(sm) {
      position: absolute;
      top: -70px;
      right: 0;
    }
  }
  &-product-name {
    .imgBox {
      width: 100px;
    }
  }
  &-product-text {
    font-size: 14px;
    color: $platform_main;
  }
  &-product-title {
    font-size: 16px;
    @include media-breakpoint-down(md) {
      font-size: 14px;
    }
  }
  &-footer {
    span {
      font-size: 20px;
      font-weight: bold;
    }
  }
}
</style>
<script>
import { Toast } from "@/plugins/sweetalert2.js";
import { Order } from "@/assets/api/platform.js";
import "@/assets/js/dateFormat.js";

export default {
  name: "Order",
  props: ["token", "search"],
  data() {
    return {
      hasFilter: false,
      searchOrder: "",
      orderList: null,
      pay_status: [],
      shopping_status: [],
      imageOnerror: "/img/image_onerror.jpg",
      pay_status_list: [
        {
          text: "未付款",
          value: 0
        },
        {
          text: "已付款",
          value: 1
        },
        {
          text: "部分付款",
          value: 2
        }
      ],
      shopping_status_list: [
        {
          text: "未出貨",
          value: 0
        },
        {
          text: "已出貨",
          value: 1
        },
        {
          text: "部分出貨",
          value: 2
        }
      ]
    };
  },
  created() {
    this.searchOrder = this.search || "";
    this.getOrder(1);
  },
  watch: {
    pay_status() {
      this.getOrder(1);
    },
    shopping_status() {
      this.getOrder(1);
    }
  },
  methods: {
    format(date, formatText) {
      // "yyyy-MM-dd"
      return new Date(date).format(formatText);
    },
    pagination(currentPage) {
      this.getOrder(currentPage);
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    getAllImgUrl(url) {
      return (process.env.VUE_APP_API_BASE_URL || "") + url;
    },
    getPayStatuName(val) {
      for (let i = 0; i < this.pay_status_list.length; i++) {
        if (this.pay_status_list[i].value == val) {
          return this.pay_status_list[i].text;
        }
      }
    },
    getShoppingStatuName(val) {
      for (let i = 0; i < this.shopping_status_list.length; i++) {
        if (this.shopping_status_list[i].value == val) {
          return this.shopping_status_list[i].text;
        }
      }
    },
    toThousands(num) {
      return (num || 0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, "$1,");
    },
    companyTotalPrice(id) {
      let totalPrice = 0;
      this.orderList.data.forEach(val => {
        if (val.order_serial == id) {
          val.detail.forEach(item => {
            totalPrice = totalPrice + item.price * item.count;
          });
        }
      });
      return totalPrice;
    },
    clearFilter() {
      this.pay_status = [];
      this.shopping_status = [];
      this.getOrder(1);
    },
    onerrorForImg() {
      this.$nextTick(() => {
        var imgList = document.querySelectorAll("img");
        Array.prototype.forEach.call(imgList, item => {
          item.onerror = () => {
            item.src = this.imageOnerror;
          };
        });
      });
    },
    clearOrderFilter() {
      this.searchOrder = "";
      this.getOrder(1);
    },
    getOrder(page) {
      let config = Object.assign({}, this.token);
      config.params = {
        keyword: this.searchOrder,
        pay_status: this.pay_status,
        shopping_status: this.shopping_status,
        page: page
      };
      Order.get(config)
        .then(res => {
          if (res.status <= 201) {
            this.orderList = res.data;
            this.onerrorForImg();
          } else {
            Toast.fire({
              icon: "error",
              title: "訂單資料讀取失敗",
              text: res.data.error
            });
          }
        })
        .catch(error => {
          console.error(error);
        });
    },
    searchOrderSubmit() {
      this.getOrder(1);
    }
  }
};
</script>
